import React from "react";
import PropTypes from "prop-types";
import { useMikMakAdobeTracking } from "@cotyorg/ccx-utils/js/hooks/useMikMakAdobeTracking";

/**
 * MikMak component for handling Where to Buy functionality
 * @param {Object} props
 * @param {string} props.wtbid - MikMak Where to Buy ID
 * @param {string} props.selectedSku - Selected product SKU
 * @returns {React.Component} MikMak container element
 */
const MikMakWidget = ({ wtbid, selectedSku }) => {
  useMikMakAdobeTracking();

  return (
    <div className="mikmak-widget">
      <div data-mm-wtbid={wtbid} data-mm-ids={selectedSku} />
    </div>
  );
};

MikMakWidget.propTypes = {
  wtbid: PropTypes.string.isRequired,
  selectedSku: PropTypes.string.isRequired,
};

export default MikMakWidget;
